export type ApplicationContextElement = {
  key: string;
  label: string;
  value: unknown;
};

export const OG_ASSIST_APPLICATION_DISPLAY_NAME = 'Reporting';

export const useApplicationContext = (
  activeAppKey: string,
  additionalElements?: ApplicationContextElement[]
): ApplicationContextElement[] => {
  const context: ApplicationContextElement[] = [
    {
      key: 'applicationName',
      label: 'Application ID',
      value: activeAppKey
    },
    {
      key: 'applicationDisplayName',
      label: 'Application Name',
      value: OG_ASSIST_APPLICATION_DISPLAY_NAME
    },
    {
      key: 'activeProduct',
      label: 'Active Product',
      value: activeAppKey
    }
  ];

  const pathname = window.location.pathname;
  if (pathname) {
    context.push({
      key: 'currentPage',
      label: 'Current Page',
      value: pathname
    });
  }

  const pageTitle = document.title;
  if (pageTitle) {
    context.push({
      key: 'currentPageTitle',
      label: 'Current Page Title',
      value: pageTitle
    });
  }

  if (additionalElements) {
    context.push(...additionalElements);
  }

  return context;
};
